import { useTranslation } from 'react-i18next'
import { previewParts } from './quickAnswerRules'

// What the customer receives: the text (with a `name: link` line per file), then the images.
export default function QuickAnswerPreview({ draft }) {
  const { t } = useTranslation()
  const { text, images } = previewParts(draft)
  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 p-3 text-sm" data-testid="qa-preview">
      <p className="mb-2 text-xs font-semibold uppercase text-slate-400">{t('quickAnswer.preview.title')}</p>
      {text ? (
        <p className="max-w-sm whitespace-pre-wrap break-words rounded-2xl rounded-tl-sm bg-white p-3 text-slate-900 shadow-sm">{text}</p>
      ) : (
        <p className="text-slate-400">{t('quickAnswer.preview.empty')}</p>
      )}
      {text && images.map((a) => (
        <img key={a.url} src={a.url} alt={a.filename || ''} className="mt-2 max-h-40 rounded-lg" />
      ))}
    </div>
  )
}
